import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';

interface TextareaProps {
  name?: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  rows?: number;
  readOnly?: boolean;
  maxLength?: number;
}

const Textarea = ({ value, onChange, disabled, readOnly, className, ...rest }: TextareaProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const _onChange = (e) => {
    if (disabled || !onChange) return;
    onChange(e.target.value);
  };

  useEffect(() => {
    const textarea = textareaRef.current;

    if (textarea && readOnly) {
      const handleFocusAndClick = () => {
        textarea.select();
      };

      textarea.addEventListener('focus', handleFocusAndClick);
      textarea.addEventListener('click', handleFocusAndClick);

      return () => {
        textarea.removeEventListener('focus', handleFocusAndClick);
        textarea.removeEventListener('click', handleFocusAndClick);
      };
    }
  }, [readOnly]);

  return (
    <textarea
      ref={textareaRef}
      className={classnames('form-control', className, { 'text-area-read-only': readOnly })}
      value={value || ''}
      onChange={_onChange}
      disabled={disabled}
      readOnly={readOnly}
      {...rest}
    />
  );
};

export default Textarea;
